import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CourseDetailsData } from "../types/course";
import { courses } from "../types/courses";
import CourseDetails from "./courseDetails";

const CourseDetailsWrapper = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const course: CourseDetailsData | undefined = courses.find(
    (c) => c.slug === slug
  );

  if (!course) {
    return (
      <div className="text-center py-10 text-red-600">{t("courseDetail.notFound")}</div>
    );
  }

  return <CourseDetails course={course} />;
};

export default CourseDetailsWrapper;
